// extracted by mini-css-extract-plugin
module.exports = {"list":"TasksList_list__1kz-6"};